<template>
  <div class="tab-info">
    <n-divide class="tools">
      <div></div>
      <div><n-button v-if="editable" @click="$var('add', true)">Добавить сотрудника</n-button></div>
    </n-divide>
    <n-table :data="staff" :columns="columns" :loading="$var('loading')">
      <template #tools="{item}">
        <n-button round icon="file" @click="$var('user', item)" />
      </template>
      <template #delete="{item}">
        <n-button round icon="trash" @click="deleteUser(item)" />
      </template>
    </n-table>
    
    <CardCompanyInvite v-if="$var('add')" :company-id="companyId" @close="$var('add', false)" @submit="load" />
    <user-documents v-if="$var('user')" :editable="editable" :user="$var('user')" @close="$var('user', null)" />
  </div>
</template>

<script>
import CardCompanyInvite from './modals/Invite'
import UserDocuments from '../../components/userDocuments/Index'

export default {
  name: 'TabWorkers',
  components: { UserDocuments, CardCompanyInvite, },
  props: [ 'companyId', 'editable', ],
  data() {
    return {
      staff: [],
      columns: [
        { title: 'ФИО', name: 'fullName', },
        { title: 'ИИН', name: 'iin', },
        { title: 'E-mail', name: 'email', },
        { title: 'Телефон', name: 'phone', },
        { title: 'Должность', name: 'position', },
        { title: '', name: 'tools', },
        { title: '', name: 'delete', },
      ],
    }
  },
  created() {
    this.$form.init({
      iin: '',
      email: '',
      position: '',
    })
    this.$form.rules({
      iin: [ 'required', ],
      email: [ 'required', ],
      position: [ 'required', ],
    })
  },
  mounted() {
    this.load()
  },
  methods: {
    deleteUser(item) {
      this.$var('loading', true)
      $api.users.delete(item.id).then(() => {
        this.load()
      }).finally(() => {
        this.$var('loading', false)
      })
    },
    load() {
      this.$var('loading', true)
      $api.companies.workers.get(this.$route.query.id).then((response) => {
        this.staff = response.data.content
        this.$var('loading', false)
      })
    },
    submit(e) {
      if (this.$form.check()) {
        this.$var('loadingAdd', true)
        setTimeout(() => {
          this.$var('loadingAdd', false)
          setTimeout(() => {
            this.$var('add', false)
          }, 300)
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .tab-info {
    font-size: .9em;
    .tools {
      margin-bottom: 10px;
    }
  }
</style>
